import { EnumHelper } from "@singularsystems/neo-core";

export enum BusinessDayConvention {
    Following = 0,
    ModifiedFollowing = 1,
    Preceding = 2,
    ModifiedPreceding = 3,
    Actual = 4,
}

EnumHelper.decorateEnum(BusinessDayConvention, decorator => {
    decorator.describe(BusinessDayConvention.Following, "Following", "Move forward to the next business day, even if it's in the next month.");
    decorator.describe(BusinessDayConvention.ModifiedFollowing, "Modified Following", "Move forward to the next business day, unless it crosses into next month, then move backward.");
    decorator.describe(BusinessDayConvention.Preceding, "Preceding", "Move backward to the previous business day, regardless of month.");
    decorator.describe(BusinessDayConvention.ModifiedPreceding, "Modified Preceding", "Move backward unless that crosses into the previous month; then move forward.");
    decorator.describe(BusinessDayConvention.Actual, "Actual", "Payment date is the same as calculation date, even if it is a non business day.");
})